import React, { useState } from 'react';
import { Modal, message } from 'antd';
import { theme } from 'utils/style/theme';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import iconClose from 'utils/icon/icon_close_circle.svg';
import { handleMessage } from 'utils/helper/message';
import PrimaryButton from 'components/button/PrimaryButton';
import { emoticonApis } from 'apis/resource/emoticonApis';
import InputStyled from 'components/InputStyled';

/**
 * * 리소스 - 미니컷 등록 모달
 */

interface IProps {
  visible: {
    createGroup: boolean;
    editGroup: boolean;
    createEmoticon: boolean;
    editEmoticon: boolean;
    delete: boolean;
    name: string;
  };
  setVisible: (e: any) => void;
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
  refresh: boolean;
  projectId: string | undefined;
  data: any;
  setData: React.Dispatch<any>;
}

const EmoticonGroupEditModal = ({
  visible,
  setVisible,
  setRefresh,
  refresh,
  projectId,
  data,
  setData,
}: IProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  /// 서버 전송
  const handleSubmit = async () => {
    if (projectId) {
      try {
        const postData = {
          id: data.id,
          speaker: data.speaker,
          slaves: data.slaves,
        };
        setLoading(true);
        await emoticonApis.emoticonGroupEdit(projectId, data.id, {
          update: postData,
        });
        setRefresh(!refresh);
        setLoading(false);
        handleClose();
      } catch (err) {
        setLoading(false);
        handleMessage(message, 'error', 'Upload failed');
      }
    }
  };

  /// 모달 닫기
  const handleClose = () => {
    setVisible({ ...visible, editGroup: false });
    // 폼을 비워줘야 이미지 첨부한 것도 비워진다.
  };

  const handleInputChange = (value, type) => {
    const cloneData = JSON.parse(JSON.stringify(data));
    cloneData[type] = value;
    setData(cloneData);
  };

  return (
    <CustomModal
      title={t(
        'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.emoticonContent.editGroupModal.title',
      )}
      visible={visible.editGroup}
      onCancel={handleClose}
      footer={
        <ButtonWrapper>
          <PrimaryButton
            text={t('buttons.save')}
            height='40px'
            width='fit-content'
            bgColor={theme.colors.blue_500}
            textColor='#ffffff'
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.blue_500}`}
            rounded='6px'
            hoverBgColor={theme.colors.blue_600}
            activeBgColor={theme.colors.blue_800}
            selectedBgColor={theme.colors.blue_700}
            onClick={handleSubmit}
            loading={loading}
            disabled={loading}
          />
        </ButtonWrapper>
      }
      closeIcon={
        <img src={iconClose} width={20} height={20} alt='icon-close' />
      }
    >
      <SectionWarpper>
        <HeaderWrapper>
          <p>ID: {data?.id}</p>
        </HeaderWrapper>
        <p className='title'>
          {t(
            'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.emoticonContent.createGroupModal.name',
          )}
        </p>
        <InputStyled
          value={data?.speaker}
          onChange={(e) => {
            handleInputChange(e.target.value, 'speaker');
          }}
          maxLength={30}
        />
        <p className='length-subtext'>
          {typeof data?.speaker?.length === 'number'
            ? `${data?.speaker?.length}/30 characters`
            : '0/30 characters'}
        </p>
      </SectionWarpper>
    </CustomModal>
  );
};

export default EmoticonGroupEditModal;

const CustomModal = styled(Modal)`
  .ant-modal-body {
    padding: 0;
  }
  .ant-modal-content {
    box-shadow: none;
    width: 566px;
  }
  .ant-radio-wrapper {
    span {
      font-size: ${theme.fontSizes.normal};
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.2px;
      color: ${theme.colors.dark_500};
    }
  }
  .ant-modal-footer {
    margin-top: 10px !important;
  }
  ul {
    margin-left: 25px;
  }
  .ant-modal-close:hover {
    background-color: transparent;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
`;

const SectionWarpper = styled.div`
  & > * + * {
    margin-top: 8px;
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  p {
    color: ${theme.colors.dark_500};
    font-weight: ${theme.fontWeights.bold};
    font-size: ${theme.fontSizes.md};
  }
`;
